import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var Ul = styled('ul')(function (_ref) {
  var _ref2;

  var serviceTitle = _ref.serviceTitle;
  return _ref2 = {
    display: 'none',
    flexWrap: 'wrap',
    margin: 0,
    padding: 0,
    marginTop: SPACING.SCALE_1,
    width: '100%'
  }, _ref2[MEDIA_QUERIES.LARGESCREEN] = {
    display: 'flex',
    paddingTop: serviceTitle ? 0 : SPACING.SCALE_5,
    width: 'auto'
  }, _ref2;
});
export default Ul;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/unordered-list/index.js
// module id = 116
// module chunks = 0